import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'lib-stripe-payment-failure',
    templateUrl: './stripe-payment-failure.component.html',
    styleUrls: ['./stripe-payment-failure.component.css'],
    standalone: false
})
export class StripePaymentFailureComponent implements OnInit {

  ngOnInit() {}
}
